import {ProductCategory} from '../types/backend';

export const ProductCarouselType = Object.freeze({
  browseWhisky: {
    serverKey: 'browseWhisky',
    defaultQuery: `product_type:${ProductCategory.whisky.value}`,
  },
  browseOtherSpirits: {
    serverKey: 'browseOtherSpirits',
    defaultQuery: Object.values(ProductCategory)
      .filter(({value}) => value !== ProductCategory.whisky.value)
      .map(({value}) => `(product_type:${value})`)
      .join(' OR '),
  },
});
